import { render, staticRenderFns } from "./checking.vue?vue&type=template&id=5850584f&scoped=true&"
import script from "./checking.vue?vue&type=script&lang=js&"
export * from "./checking.vue?vue&type=script&lang=js&"
import style0 from "./checking.vue?vue&type=style&index=0&id=5850584f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5850584f",
  null
  
)

export default component.exports